import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增应急指挥任务
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyCommandTask/save',
        method: 'post',
        data
    })
}
// 修改应急指挥任务
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyCommandTask/update',
        method: 'post',
        data
    })
}
//查询应急指挥任务列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyCommandTask/list',
        method: 'get',
        params
    })
}
//查询应急指挥任务
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyCommandTask/detail?id=' + id,
        method: 'get',
    })
}
//删除应急指挥任务
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyCommandTask/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}
//应急指挥任务列表-分页
export function listByPerson(params) {
    return request({
        baseURL,
        url: '/emergencyCommandTask/listByPerson',
        method: 'get',
        params
    })
}